<template>
  <div class="Oct2022 text-NotoSansLight bg-oct2022">
    <div class="container py-10">
      <div class="px-4 md:px-12">
        <router-link :to="{ name: 'index' }">
          <img src="~@/assets/images/202210/LiveABC-logo.png" class="object-contain">
        </router-link>
      </div>
      <section class="banner mb-6 px-4 md:px-12">
        <div class="">
          <img src="~@/assets/images/202210/master-visaul.png" class="object-contain mx-auto">
        </div>
      </section>
      <section class="section1 mb-10 px-4 md:px-12">
        <div class="bg-white p-4 md:p-6 rounded-3xl box-shadow">
          <div class="py-3">
            <img src="~@/assets/images/202210/title-01.png" class="object-contain mx-auto">
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2 md:p-4" v-for="(item, index) in magData" :key="index" :class="item.class">
              <img src="@/assets/images/preset_item_small.png" class="object-contain mx-auto" v-if="!item.img_url">
              <img v-lazy="item.img_url" class="object-contain mx-auto" v-else>
            </router-link>
            <div class="w-full md:w-1/2 p-2 md:p-4">
              <img src="~@/assets/images/202210/MG-LIVEPEN-07.png" class="object-contain mx-auto">
            </div>
          </div>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=178" target="_blank" class="flex items-center mt-4 py-4">
            <div class="flex-1 border-dotted border-t-4 border-black"></div>
            <div class="box-shadow bg-oct2022 rounded-lg w-auto border-2 border-black py-2 px-4 font-semibold tracking-widest-oct text-xl mx-4">
              <p>活動頁詳情</p>
            </div>
            <div class="flex-1 border-dotted border-t-4 border-black"></div>
          </a>
        </div>
      </section>
      <section class="section2 mb-10 px-4 md:px-12">
        <div class="rounded-3xl bg-oct2022-dark p-4 md:p-8 box-shadow">
          <div class="py-4 md:py-6">
            <img src="~@/assets/images/202210/title-02.png" class="object-contain mx-auto">
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="p-2" v-for="(item, index) in sectionData" :key="index" :class="item.class">
              <div class="bg-white p-4 h-full rounded-3xl">
                <img src="@/assets/images/preset_item_small.png" class="object-contain mx-auto" v-if="!item.img_url">
                <img v-lazy="item.img_url" class="object-contain mx-auto" v-else>
              </div>
            </router-link>
          </div>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=184" target="_blank" class="flex items-center mt-4 py-4">
            <div class="flex-1 border-dotted border-t-4 border-white"></div>
            <div class="box-shadow bg-oct2022 rounded-lg w-auto border-2 border-black py-2 px-4 font-semibold tracking-widest-oct text-xl mx-4">
              <p>點我看更多商品</p>
            </div>
            <div class="flex-1 border-dotted border-t-4 border-white"></div>
          </a>
        </div>
      </section>
      <section class="section2 p-6 px-4 md:px-12">
        <div class="p-4">
          <img src="~@/assets/images/202210/title-03.png" class="object-contain mx-auto">
        </div>
        <div class="p-4">
          <img src="~@/assets/images/202210/pigai-info.png" class="object-contain mx-auto">
        </div>
        <div class="p-4">
          <img src="~@/assets/images/202210/pigai-logo.png" class="object-contain mx-auto">
        </div>
        <a class="p-4" href="https://store.liveabc.com/products/magazine/sale?tag=185">
          <img src="~@/assets/images/202210/pigai-visaul.png" class="object-contain mx-auto">
        </a>
        <div class="p-4">
          <img src="~@/assets/images/202210/under-bar.png" class="object-contain mx-auto">
        </div>
        <router-link :to="{ name: 'index' }" class="p-4">
          <img src="~@/assets/images/202210/go-liveabc-bt.png" class="object-contain mx-auto">
        </router-link>
        <p class="text-xl text-center tracking-widest mt-4">詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Oct2022',
  metaInfo () {
    return {
      title: '光輝10月搶一波優惠先',
      titleTemplate: null
    }
  },
  components: {
  },
  data () {
    return {
      sectionData: [
        { id: 7797, img_url: require('@/assets/images/202210/book-01_1.png'), class: 'w-1/2' },
        { id: 7385, img_url: require('@/assets/images/202210/book-02_1.png'), class: 'w-1/2' },
        { id: 6556, img_url: require('@/assets/images/202210/book-03_1.png'), class: 'w-1/2 md:w-1/3' },
        { id: 7524, img_url: require('@/assets/images/202210/book-04.png'), class: 'w-1/2 md:w-1/3' },
        { id: 7411, img_url: require('@/assets/images/202210/book-05.png'), class: 'w-1/2 md:w-1/3' },
        { id: 7389, img_url: require('@/assets/images/202210/book-06.png'), class: 'w-1/2 md:w-1/3' },
        { id: 6596, img_url: require('@/assets/images/202210/book-07.png'), class: 'w-1/2 md:w-1/3' },
        { id: 7954, img_url: require('@/assets/images/202210/book-08.png'), class: 'w-1/2 md:w-1/3' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.box-shadow {
  box-shadow:
    0.8px 0.8px 0px rgba(0, 0, 0, 0.5),
    6px 6px 0px rgba(0, 0, 0, 0.6);
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.bg-oct2022 {
  background-color: #ffcf33;
}
.bg-oct2022-dark {
  background: #241c2f;
}
.tracking-widest-oct {
  letter-spacing: 0.3em;
}
.Oct2022 {
  .container {
    background-image: url('~@/assets/images/202210/radiance.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;
  }
}
</style>
